import React, { useEffect, useState} from 'react';
import { useTheme } from '@mui/material/styles';
import DatePicker from 'react-datepicker';
import moment from 'moment'
import { isBefore } from 'date-fns';
import { Box, InputAdornment, TextField, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FechaFunction from '../../function/FechaFunction';

const DateRangeMaxSeven = ({
    minDate,
    onChange,
    isDisabled,
    isDisabledHasta,
    initianDate,
    isClearable,
    texto1 = 'Desde',
    texto2 = 'Hasta'
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [startDate, setStartDate] = useState(initianDate?.startDate);
    const [endDate, setEndDate] = useState(initianDate?.endDate);
    const CustomInput = React.forwardRef(
        ({value: valueField, onClick}, ref) => (
            <TextField
                onClick={onClick}
                value={valueField}
                ref={ref}
                readOnly
                autoComplete='off'
                focused
                InputProps={{
                    startAdornment: (
                        <Box sx={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems: 'center',alignContent:'center', backgroundColor: isDarkMode ? '#1a3a5c' : '#b1cfff',height:{xs:41,xl:42},width:50,marginLeft:-1.7,borderTopLeftRadius:4,borderBottomLeftRadius:5}}>
                            <InputAdornment position="start">
                                <CalendarMonthIcon sx={{color: isDarkMode ? '#90caf9' : '#0364ff',marginLeft:1}} />
                            </InputAdornment>
                        </Box>
                    ),
                }}
                sx={{
                    '& fieldset': {
                        borderColor: isDarkMode ? '#3d4a62' : '#ccc',
                    },
                    '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                        borderBottomRightRadius: 10,
                        borderTopRightRadius:10,
                        borderColor: isDarkMode ? '#90caf9' : '#b1cfff',
                        },
                    },
                    '& input': {
                        color: isDarkMode ? '#e0e0e0' : '#000',
                        background: isDarkMode ? '#2d3a52' : '#fff',
                        borderBottomRightRadius: 10,
                        borderTopRightRadius:10,
                        height:10,
                        textAlign: 'center',
                        fontWeight: 'bold'
                    },
                }}
            />
        )
    );
    const onChangeData = (destino,fecha) =>{
        if(destino === 'start'){
            const anterior = isBefore(endDate,fecha)
            setStartDate(fecha)
            if(anterior){
                setEndDate(fecha)
                onChange({
                    startDate: fecha,
                    endDate: fecha
                })
            }else{
                onChange({
                    startDate: fecha,
                    endDate
                })
            }
        }else{
            setEndDate(fecha)
            onChange({
                startDate,
                endDate: fecha
            })
        }
    }
    useEffect(() => {
        if(initianDate?.startDate){
            setStartDate( FechaFunction.parse(initianDate.startDate))
        }
        if(initianDate?.endDate){
            setEndDate( FechaFunction.parse(initianDate.endDate))
        }
    }, [initianDate])
    return (
        <Box display='flex'>
            <Box display='block'>
                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}}>
                    {texto1}
                </Typography>
                <DatePicker
                    selected={startDate}
                    onChange={(date) => onChangeData('start',date)}
                    dateFormat="P"
                    disabled={isDisabled}
                    customInput={<CustomInput />}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    minDate={minDate || new Date()}
                    popperPlacement="auto"
                    isClearable={isClearable && startDate}
                />
            </Box>
            <Box display='block' ml={2}>
                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}}>
                    {texto2}
                </Typography>
                <DatePicker
                    selected={endDate}
                    onChange={(date) => onChangeData('end',date)}
                    dateFormat="P"
                    disabled={isDisabled || !startDate || isDisabledHasta}
                    customInput={<CustomInput />}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    maxDate={moment(startDate).add(13, 'days').toDate()}
                    popperPlacement="auto"
                    isClearable={isClearable && endDate}
                />
            </Box>
        </Box>
    );
}

export default DateRangeMaxSeven;
